export enum DigitalWalletPlatform {
    AW = 'AW',
    GW = 'GW',
    SW = 'SW'
}
